/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-11 22:56:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-26 18:34:47
 * @FilePath: /code/zeelool-nextjs/src/api/cart.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BaseCartRequestData } from '@/app/_lens-components/types';
import { httpRequest } from '@/utils/axios';
import { recordCartV1RecentAdd, readCartV1RecentAddScope } from '@/utils/cart-v1-recent-add';
import type { ApiParamsDefinition } from './types/api-definition';
import { ICartListResponse, ICartPriceResponse, IGetCartPrice } from './types/cart';

type CartApiResponseEnvelope = {
  code?: number;
  msg?: string;
  trace_id?: string;
  data?: unknown;
};

type GeneratedNewCartListQuery = ApiParamsDefinition['GET:/api/cart/v2/lists']['params'];
type NewCartListQuery = Omit<GeneratedNewCartListQuery, 'cart_ids'> & {
  cart_ids?: GeneratedNewCartListQuery['cart_ids'] | Array<string | number>;
  currency?: string;
};
type GeneratedCartPriceRequest = ApiParamsDefinition['GET:/api/cart/get_cart_price'];

// OpenAPI 暂未包含赠品扩展响应，类型转换只允许发生在 cart API 边界。
const withCartResponse = async <TResponse extends CartApiResponseEnvelope>(
  request: Promise<CartApiResponseEnvelope>,
): Promise<TResponse> => {
  const response = await request;
  return response as TResponse;
};

// 生成定义把该 GET 接口误标为 data；运行时必须继续通过 params 发送查询参数。
const cartPriceQuery = (params: IGetCartPrice) =>
  ({ params }) as unknown as GeneratedCartPriceRequest;

const newCartListQuery = (params: NewCartListQuery) =>
  ({ params }) as unknown as ApiParamsDefinition['GET:/api/cart/v2/lists'];

// 获取购物车列表
export const getNewCartList = (params: NewCartListQuery) =>
  withCartResponse<ICartListResponse>(
    httpRequest('GET:/api/cart/v2/lists', newCartListQuery(params)),
  );

// 获取购物车列表（旧版本）
export const getCartList = () => httpRequest('GET:/api/cart/lists');

// 加入购物车
export const addToCart = async (data: BaseCartRequestData) => {
  const requestScope = readCartV1RecentAddScope();
  // 删除 origin_option 字段，避免修改 data 影响其他逻辑
  if (data && data.origin_option) {
    data = Object.assign({}, data);
    delete data.origin_option;
  }
  const response = await httpRequest('POST:/api/cart/store', { data });
  const cartId = response?.data?.cart_id;
  if (
    response?.code === 200 &&
    Number.isSafeInteger(cartId) &&
    cartId > 0 &&
    typeof window !== 'undefined'
  ) {
    try {
      recordCartV1RecentAdd([cartId], requestScope);
    } catch {
      // 本地选择凭据是可选能力，不影响成功加购和调用方后续行为。
    }
  }
  return response;
};

// 更新购物车
export const updateCart = (data: BaseCartRequestData) => {
  // 删除 origin_option 字段，避免修改 data 影响其他逻辑
  if (data && data.origin_option) {
    data = Object.assign({}, data);
    delete data.origin_option;
  }
  return httpRequest('PUT:/api/cart/update', { data }, { success: false, fail: false });
};

// 删除购物车
export const deleteCart = (data: { cart_ids?: number[] }) =>
  httpRequest('DELETE:/api/cart/delete', { data });

// 加入特殊类型到购物车
export const specialCartStore = (data: {
  currency?: string;
  data?: Array<{
    type?: number;
    relation_id?: number;
    products?: Array<{
      product_id?: number;
      conversion_qty?: number;
      cart_id?: string;
      option?: any;
      prescription_recognition_id?: number;
    }>;
  }>;
}) => httpRequest('POST:/api/cart/special_store', { data });

// 刷新购物车（执行合并购物车，自动删除购物车
export const refreshCarts = () => httpRequest('GET:/api/cart/refresh');

// 获取购物车总的价格
export const getSubTotalPrice = (params: IGetCartPrice) =>
  withCartResponse<ICartPriceResponse>(
    httpRequest('GET:/api/cart/get_cart_price', cartPriceQuery(params)),
  );

// 获取包邮政策
export const getFreeShippingPolicy = (params: { currency?: string; cart_ids?: number[] }) =>
  httpRequest('GET:/api/cart/free_shipping_policy', { params } as any);

// 购物车跳转结算页面前检查
export const checkCartBeforeCheckout = (data: { cart_ids?: string[] }) =>
  httpRequest('POST:/api/cart/check', { data });

// 获取第二件半价信息
export const getHalfPrice = () => httpRequest('GET:/api/public/half_price');
